import type { FaireProductEntity } from "../../entity_types/product";

export const p_fqggnmpyca: FaireProductEntity = {
  token: "p_fqggnmpyca",
  type: "product",
  name: "Rose Quartz Point",
  brandToken: "b_ciwhgi8nfq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/261f77d7b9c7ce73ffdd8cb616d1f91e83be760786f16b0acd0fb4bcfbd05cba.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e1ae46852bd44af9559416ea3f9275b6c1bd473d85e500f5bb8bd21304ec837a.jpeg",
    "https://cdn.faire.com/fastly/83ce7998145f3e463a75e34b692eff4cc9678a8f2954b3a5e055d06bb0255515.jpeg",
    "https://cdn.faire.com/fastly/ae62b154e87c85cb589ba64df4b160923544f70ccf6dc5fa7bbd3c914dc29d4d.jpeg",
    "https://cdn.faire.com/fastly/ee41eee4941fffbb1a9883cf198a26e7faae074aae1dac67c53896e8d236dc93.jpeg",
  ],
  priceDollars: 7,
  description:
    '\nThis listing is for one small Rose Quartz point\n\nSize: approximately 3" - 4"\n\nDue to the unique nature of crystals and minerals, the actual specimen you receive may vary slightly from those pictured.\n\n🌸💗 Rose Quartz Tower – 1pc\nSoft, soothing, and heart-centered, this Rose Quartz Tower is a beautiful addition to any crystal selection. With its gentle pink coloring and polished point, it’s perfect for décor, energy work, and gifting.\n✨ Product Details\n\n\nMaterial: Natural Rose Quartz\n\n\nShape: Polished tower/point\n\n\nColor: Soft to medium pink tones\n\n\nFinish: Smooth, glossy polish\n\n\nQuantity: 1 tower (each piece is unique)\n\n\n💫 Features & Selling Points\n\n\nRose quartz is the stone of love, compassion, and emotional healing\n\n\nPerfect for nightstands, desks, altar spaces, and relaxation areas\n\n\nSmooth polished finish makes it a beautiful display piece\n\n\nGreat for gift bundles, Valentine’s collections, and heart chakra sets\n\n\nNatural variations in clarity and tone make each tower one-of-a-kind\n\n\nA timeless crystal favorite, this Rose Quartz Tower brings warmth, reassurance, and loving energy to any curated inventory.',
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:38.397Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
